import { usePrevious } from '@ovpn-ui/utils';
import { useEffect } from 'react';
import { useDimensions, useMobileSidebar } from '../../hooks';
import { emitMobileSidebarToggleEvent, emitDesktopSidebarToggleEvent } from '../../sidebarState';
export function useBreakpointTransition() {
  const [isMobileSidebarOpened] = useMobileSidebar();
  const {
    isMobile
  } = useDimensions();
  const previousIsMobile = usePrevious(isMobile);
  useEffect(() => {
    const isNewBreakpoint = previousIsMobile !== isMobile && previousIsMobile !== undefined;
    const isSwitchedToDesktop = isNewBreakpoint && !isMobile;
    const isSwitchedToMobile = isNewBreakpoint && isMobile;
    if (isSwitchedToDesktop) {
      emitDesktopSidebarToggleEvent(isMobileSidebarOpened);
      emitMobileSidebarToggleEvent(false);
    } else if (isSwitchedToMobile) {
      emitDesktopSidebarToggleEvent(false);
    }
  }, [isMobile, isMobileSidebarOpened, previousIsMobile]);
}